module.exports = __webpack_public_path__ + "logo-1.png?8ca1515a40a38eec8ae82626121b30ba";


//////////////////
// WEBPACK FOOTER
// ./src/assets/img/logo-1.png
// module id = 381
// module chunks = 0